import config from '@/common/config'
import { ModelApiService } from './BaseApiService'

export default class FormsApiService extends ModelApiService {
  constructor() {
    super(
      'submissions',
      `${config.get('forms2.api.url')}v${config.get('forms2.api.version')}/`
    )
  }

  async getFormSubmissionAndSchemaByPasskey(passkey) {
    return await this.get(`${passkey}/full`)
  }

  async downloadFile(passkey, fileId) {
    return await this.getBlob(`${passkey}/files/${fileId}`)
  }

  async generatePdf(passkey) {
    return await this.postBlob(`${passkey}/pdf`)
  }

  async downloadStampedPdf(passkey) {
    return await this.getBlob(`${passkey}/stamped-pdf`)
  }

  async createFormSubmission(formId, formVersionNo, values) {
    return await this.post(``, { formId, formVersionNo, values })
  }

  async deleteFormSubmission(passkey) {
    return await this.delete(`${passkey}`)
  }
}
